import Avatar from "./Avatar";
import Logo from "./icons/Logo";

const AvatarButton = ({ user, ring, isSystem, small }) => {
  if (isSystem) {
    return (
      <div className="shrink-0 inline-block bg-primary-600 rounded-full overflow-hidden h-8 w-8 p-1.5">
        <Logo className="h-full w-full text-white" />
      </div>
    );
  }

  return (
    <div
      className={`shrink-0 inline-block bg-gray-100 rounded-full ${small ? "h-6 w-6" : "h-8 w-8"
        }`}
    >
      <Avatar user={user} ring={ring} />
    </div>
  );
};

export default AvatarButton;
